const dashboard = {
  user_dash_title: 'Panneau utilisateur',
  user_dash_profile: 'Profil',
  user_dash_favorites: 'Favoris',
  user_dash_consultations: 'Consultations',
  user_dash_compare: 'Comparer',
  user_dash_recommendations: 'Recommandations',
  user_dash_diary: 'Journal de traitement',
  user_dash_notifications: 'Notifications',
  user_dash_contracts: 'Contrats',
  user_dash_password: 'Changer le mot de passe',
  user_dash_logout: 'Déconnexion',

  inst_dash_title: 'Panneau établissement',
  inst_dash_overview: 'Aperçu',
  inst_dash_profile: 'Profil de l\'établissement',
  inst_dash_appointments: 'Gestion des rendez-vous',
  inst_dash_analytics: 'Analytique',
  inst_dash_membership: 'Adhésion',
  inst_dash_contracts: 'Contrats',
  inst_dash_reconciliation: 'Réconciliation',
  inst_dash_notifications: 'Notifications',
  inst_dash_logout: 'Déconnexion',

  admin_dash_title: 'Panneau admin',
  admin_dash_overview: 'Aperçu',
  admin_dash_institutions: 'Gestion des établissements',
  admin_dash_users: 'Gestion des utilisateurs',
  admin_dash_consultations: 'Consultations',
  admin_dash_contracts: 'Gestion des contrats',
  admin_dash_packages: 'Gestion des forfaits',
  admin_dash_stats: 'Statistiques',
  admin_dash_reports: 'Rapports',
  admin_dash_settings: 'Paramètres',
  admin_dash_logout: 'Déconnexion',

  user_dash_welcome: 'Bienvenue, {{name}}',
  user_dash_tab_profile: 'Profil & Notifications',
  user_dash_tab_consultations: 'Mes demandes de consultation',
  user_dash_tab_contracts: 'Mes contrats',
  user_dash_tab_password: 'Changer le mot de passe',
  user_dash_loading: 'Vérification de la session...',
  user_dash_remember_me: 'Se souvenir de moi',
  user_dash_back_to_login: 'Retour à la page de connexion',
  user_dash_forgot_title: 'Mot de passe oublié',
  user_dash_forgot_desc: 'Entrez votre adresse e-mail enregistrée et nous vous enverrons un lien de réinitialisation.',
  user_dash_forgot_send: 'Envoyer le lien de réinitialisation',
  user_dash_forgot_sending: 'Envoi en cours...',
  user_dash_forgot_sent_title: 'E-mail envoyé!',
  user_dash_forgot_sent_desc: 'Un lien de réinitialisation a été envoyé à <strong>{{email}}</strong>.',
  user_dash_forgot_spam: 'Si vous ne trouvez pas l\'e-mail, vérifiez votre dossier spam.',
  user_dash_back_to_login_btn: 'Retour à la connexion',
  user_dash_login_title: 'Connexion utilisateur',
  user_dash_login_desc: 'Gérez votre compte et consultez vos contrats',
  user_dash_fill_all: 'Veuillez remplir tous les champs',
  user_dash_login_failed: 'Connexion échouée',
  user_dash_no_account: 'Pas de compte?',
  user_dash_register: 'S\'inscrire',
  email_change_title: 'Changement d\'e-mail',
  email_change_subtitle: 'Vos identifiants de connexion seront mis à jour',
  email_change_desc: 'Vous changez votre adresse e-mail en <strong>{{email}}</strong>.',
  email_change_warning: 'Après ce changement, vous devrez vous connecter avec votre <strong>nouvelle adresse e-mail</strong>.',
  email_change_confirm: 'Oui, mettre à jour',
  email_change_saving: 'Enregistrement...',
  email_change_cancel: 'Annuler',
  profile_user_id: 'ID utilisateur',
  profile_copy: 'Copier',
  profile_copied: 'Copié!',
  profile_title: 'Informations du profil',
  profile_saved: 'Modifications enregistrées.',
  profile_gender: 'Genre',
  profile_male: 'Homme',
  profile_female: 'Femme',
  profile_other: 'Préfère ne pas dire',
  profile_first_name: 'Prénom',
  profile_last_name: 'Nom de famille',
  profile_email: 'E-mail',
  profile_phone: 'Téléphone',
  profile_country: 'Pays',
  profile_country_placeholder: 'Sélectionner un pays',
  profile_city: 'Ville',
  profile_city_placeholder: 'Sélectionner une ville',
  profile_city_select_country: 'Sélectionner d\'abord un pays',
  profile_search_country: 'Rechercher un pays...',
  profile_search_phone: 'Rechercher un pays ou un code...',
  profile_no_result: 'Aucun résultat trouvé',
  profile_save_btn: 'Enregistrer les modifications',
  notif_title: 'Préférences de notification',
  notif_desc: 'Choisissez les notifications que vous souhaitez recevoir',
  notif_saved: 'Préférences de notification enregistrées.',
  notif_email_consult: 'Notification e-mail de demande de consultation',
  notif_email_consult_desc: 'Recevoir un e-mail lorsque le statut de la demande change',
  notif_email_newsletter: 'E-mails de newsletter',
  notif_email_newsletter_desc: 'Rester informé des développements du tourisme de santé',
  notif_sms_consult: 'Notification SMS',
  notif_sms_consult_desc: 'Recevoir un SMS lorsque la demande de consultation est approuvée',
  notif_sms_reminder: 'Notifications de rappel',
  notif_sms_reminder_desc: 'Recevoir un rappel avant la consultation',
  notif_save_btn: 'Enregistrer les préférences',
  pwd_title: 'Changer le mot de passe',
  pwd_saved: 'Votre mot de passe a été changé avec succès.',
  pwd_current: 'Mot de passe actuel',
  pwd_new: 'Nouveau mot de passe',
  pwd_new_placeholder: 'Au moins 6 caractères',
  pwd_confirm: 'Confirmer le nouveau mot de passe',
  pwd_confirm_placeholder: 'Ressaisir le mot de passe',
  pwd_mismatch: 'Les mots de passe ne correspondent pas',
  pwd_submit: 'Changer le mot de passe',
  pwd_verifying: 'Vérification...',
  pwd_strength_weak: 'Faible',
  pwd_strength_medium: 'Moyen',
  pwd_strength_strong: 'Fort',
  pwd_err_current: 'Entrez votre mot de passe actuel',
  pwd_err_min: 'Le nouveau mot de passe doit comporter au moins 6 caractères',
  pwd_err_mismatch: 'Les nouveaux mots de passe ne correspondent pas',
  pwd_err_same: 'Le nouveau mot de passe ne peut pas être identique au mot de passe actuel',
  pwd_err_unexpected: 'Une erreur inattendue s\'est produite. Veuillez réessayer.',
  consult_tab_loading: 'Chargement...',
  consult_tab_empty: 'Vous n\'avez pas encore de demandes de consultation',
  consult_tab_explore: 'Explorer les établissements',
  consult_tab_cancel: 'Annuler',
  consult_tab_cancel_confirm: 'Êtes-vous sûr de vouloir annuler cette demande de consultation?',
  consult_tab_cancelled: 'Demande de consultation annulée',
  consult_tab_cancel_failed: 'Annulation échouée',
  consult_tab_evaluate: 'Évaluer',
  consult_tab_view_inst: 'Voir l\'établissement',
  consult_tab_appt_info: 'Informations sur le rendez-vous',
  consult_tab_appt_date: 'Date',
  consult_tab_appt_note: 'Note',
  consult_tab_review_title: 'Écrire un avis',
  consult_tab_review_rating: 'Votre note',
  consult_tab_review_comment: 'Votre commentaire',
  consult_tab_review_comment_ph: 'Partagez votre expérience...',
  consult_tab_review_recommend: 'Je recommande cet établissement',
  consult_tab_review_submit: 'Soumettre',
  consult_tab_review_cancel: 'Annuler',
  consult_tab_review_sent: 'Votre avis a été soumis et sera publié après approbation',
  consult_tab_review_failed: 'L\'avis n\'a pas pu être soumis',
  consult_tab_load_failed: 'Les demandes de consultation n\'ont pas pu être chargées',
  consult_tab_status_waiting: 'En attente',
  consult_tab_status_appointed: 'Rendez-vous donné',
  consult_tab_status_completed: 'Terminé',
  consult_tab_status_cancelled: 'Annulé',
  consult_tab_status_rejected: 'Rejeté',
  contracts_title: 'Mes contrats',
  contracts_desc: 'Vous pouvez consulter les contrats que vous avez approuvés et leurs versions actuelles.',
  contracts_loading: 'Chargement...',
  contracts_empty: 'Aucun contrat trouvé pour l\'instant',
  contracts_agreed_version: 'Version que vous avez approuvée',
  contracts_outdated: 'Version actuelle: {{version}} disponible',
  contracts_up_to_date: 'Vous avez approuvé la version actuelle',
  contracts_not_agreed: 'Vous n\'avez pas encore approuvé ce contrat',
  contracts_current_version: 'Version actuelle',
  contracts_effective_date: 'Date d\'entrée en vigueur',
  contracts_view_full: 'Voir le contenu complet',
  contracts_close: 'Fermer',
  contracts_version_label: 'Version',
  contracts_type_user_terms: 'Accord d\'adhésion et d\'utilisation du site',
  contracts_type_user_kvkk: 'Accord de consentement KVKK',
  contracts_type_user_marketing: 'Accord de communication marketing',
  login_email: 'E-mail',
  login_password: 'Mot de passe',
  login_submit: 'Connexion',
  login_logging_in: 'Connexion en cours...',
  login_error: 'E-mail ou mot de passe invalide.',
  login_forgot_password: 'Mot de passe oublié?',
  login_no_account: 'Pas de compte?',
  login_register: 'S\'inscrire',
  login_user_title: 'Connexion utilisateur',
  login_institution_title: 'Connexion établissement',
  login_admin_title: 'Connexion admin',
};

export default dashboard;
